import BaseApplicationRecord from '../ApplicationRecord';

const ApplicationRecord = BaseApplicationRecord.extend({
  static: {
    apiNamespace: '/vitality_promotions',
  },
});

export default ApplicationRecord;
